const TemperatureControlledAmbient = () => {
  return (
    <div>
          
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

          <div className="px-1 flex flex-col justify-center llg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Temperature Controlled and Ambient Warehousing
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS offers dedicated, temperature controlled and ambient warehouses for the storage, preparation, 
              and dispatch of products, generally operating at four different temperature ranges: ambient (15–32°C), 
              cool (10–15°C), refrigerated (0–10°C), frozen (-30–0°C).
              </p>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                Our temperature controlled warehouses are made up of storage systems, handling equipment, and other 
                elements that facilitate operations to avoid breaking the cold chain, complying with safety standards, 
                and preserving the quality of the goods stored.
            </p>
           
          </div>
          <div className="flex-1 flex flex-col justify-center items-center lg:mt-[0rem] mt-[1rem]">
            <img src="/warehousing/TC&AW-Inside.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>

      </div>

    </div>
    );
  };
  
export default TemperatureControlledAmbient;
  